<template lang="pug">
.position-relative
  .navigation
    .position-back
      .button.is-small(
        @click="$emit('prev')"
      )
        span.icon.is-small
          i.fa.fa-arrow-left
        span Previous step
  .step-title
    span Select a pool port

  .feature-helvetica.step-explanation
    span You may select any port, this will not affect your mining performance, it depends on your preference or can be used to prevent network restrictions on specific ports.
  .features.address-info
    .columns.is-multiline.features
      .column.is-half-mobile(v-for="o in region.sslPorts" )
        .box-container
          .element-box-container.is-best(@click="selectPort(o, true)")
            span.tag Recommended
            span.name {{ o }}
            br
            span.subname SSL
      .column.is-half-mobile(v-for="o in region.alternativePorts")
        .box-container
          .element-box-container(@click="selectPort(o, false)")
            span.name {{ o }}
            br
            span.subname TCP

</template>

<script>
export default {
  name: 'c_step_region',
  props: ['mode', 'region'],
  data () {
    return {
    }
  },
  created () {
    let vm = this
    if (vm.mode === 'basic') {
      if (vm.region.sslPorts && vm.region.sslPorts.length > 0) {
        vm.$emit('selected', { number: vm.region.sslPorts[0], ssl: true })
      } else {
        vm.$emit('selected', { number: vm.region.defaultPort, ssl: false })
      }
    }
  },
  mounted () {
    document.getElementById('step').scrollIntoView();
  },
  methods : {
    selectPort (port, ssl) {
      let vm = this
      let obj = {
        number: port,
        ssl: ssl
      }
      vm.$emit('selected', obj)
    }
  }
}
</script>

<style lang="stylus" scoped>
.features
  .box-container
    margin-top 10px 0px
    .element-box-container
      margin 0
      max-height 96px
      &.is-best
        margin-bottom 10px
      .name
        font-size: 15px;
        font-weight: 700;
        text-transform: uppercase;
        letter-spacing: 1px;
      .subname
        font-size 13px
    .is-best
      position relative 
      border 5px solid #b6ffb6
      
      &:hover
        box-shadow 0 0 20px -10px
      .tag
        border-radius 0px
        background-color #b6ffb6
        font-weight bold
        display inline-block
        position absolute
        top -1px
        left -3px
        padding-top 2px
  .column
    padding-bottom 0px

@media (max-width: 965px)
  .gs
    .columns
      display flex
      .column
        width 50%
        max-width 50%
        min-width 50%
</style>



// WEBPACK FOOTER //
// c_step_port.vue?1d7e9b89